export default {"src":"/_next/static/media/roadwise-warranty-logo-dark-fr.2cc36c87.svg","height":46,"width":109,"blurWidth":0,"blurHeight":0};